module.exports = __webpack_public_path__ + "media/images/map-0fbc3d1f52364c8a3effcba8515de731.png";